import { combineReducers } from '@reduxjs/toolkit'

// Importar reducers dos módulos (serão adicionados conforme implementação)
import { authReducer } from './modules/auth/reducer'
import { cartReducer } from './modules/cart/reducer'
import { catalogReducer } from './modules/catalog/reducer'
import { checkoutReducer } from './modules/checkout/reducer'
import { ordersReducer } from './modules/orders/reducer'
import { adminReducer } from './modules/admin/reducer'
import { uiReducer } from './modules/ui/reducer'

/**
 * Root reducer que combina todos os reducers da aplicação
 */
export const rootReducer = combineReducers({
  auth: authReducer,
  cart: cartReducer,
  catalog: catalogReducer,
  checkout: checkoutReducer,
  orders: ordersReducer,
  admin: adminReducer,
  ui: uiReducer,
})

export type RootState = ReturnType<typeof rootReducer>

